const SvgNetworking3 = (props) => (
  <>
    <circle cx={96} cy={96} r={24} fill={props.p20} />
    <circle cx={144} cy={32} r={24} fill={props.p20} />
    <circle cx={64} cy={32} r={24} fill={props.p20} />
    <circle cx={16} cy={96} r={24} fill={props.p20} />
    <ellipse cx={176} cy={96} rx={24} ry={23.5} fill={props.p20} />
    <circle cx={144} cy={160} r={24} fill={props.p20} />
    <circle cx={64} cy={160} r={24} fill={props.p20} />
  </>
);

export default SvgNetworking3;
